/* eslint-disable react/no-danger */

import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';

import { AppContext } from '@prisjakt/ui-app-context';

function sanitizeParamForMarkdown(param) {
  return param
    .toString()
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function sanitizeParamsForMarkdown(params) {
  return Object.keys(params).reduce(
    (sanitizedParams, key) => ({
      ...sanitizedParams,
      [key]: sanitizeParamForMarkdown(params[key]),
    }),
    {}
  );
}

const Translate = ({ domain, children, ...params }) => {
  const context = useContext(AppContext);

  if (!context.Translate) {
    return <span>{children}</span>;
  }

  const isMarkdown = children && children.slice(-3) === '.md';
  const text = context.Translate(
    domain,
    children,
    isMarkdown ? sanitizeParamsForMarkdown(params) : params
  );

  return isMarkdown ? (
    <span dangerouslySetInnerHTML={{ __html: text }} />
  ) : (
    <span>{text}</span>
  );
};

const { string, node } = PropTypes;

Translate.propTypes = {
  domain: string.isRequired,
  children: node.isRequired,
};

export default memo(Translate);
